/* eslint-disable */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, RefObject, useEffect } from 'react'
import { isMobile } from 'react-device-detect'
// img
import useRootStore from '@store/useRootStore'
import { CHAT_TAB_INDEX_KEY } from '@constants/index'
import TextArea from 'antd/lib/input/TextArea'
import { ChatContent } from '@views/Popup/Chat/ChatItem/ChatContent'

interface ChatItemProps {
  parentRefs: RefObject<{ [key: string]: HTMLUListElement }>
  chatInputAreaRef: RefObject<HTMLDivElement>
  chatInputRef: RefObject<TextArea>
  showKeyboard: boolean
}

export const ChatItem: React.FC<ChatItemProps> = observer((props: ChatItemProps) => {
  const { chattingStore } = useRootStore()
  const {
    allChatMessageList, replyChatMessageList, shardBetHistoryChatMessageList,
    currentTabIndexKey, chatAreaScrolledToBottom,
    chatMessageSending, isVisibleChattingModal, chattingOptions, userChatOptions = {},
    blockUserListObject, favoriteUserListObject,
  } = chattingStore
  const { parentRefs, chatInputAreaRef } = props

  const { onlyFavoriteUserMessage, fontSize } = userChatOptions

  const chatListScrollHandler = (e) => {
    const currentNode = parentRefs.current[currentTabIndexKey] // tab ul element
    const clientRect = currentNode?.getBoundingClientRect()
    const clientBottom = Math.round(clientRect.bottom)
    let scrollToBottom: boolean
    if (isMobile) {
      scrollToBottom = (window.innerHeight - clientBottom - chatInputAreaRef.current.offsetHeight) >= 0
      if (chattingStore.isVisibleCheerForTeamPanel) {
        scrollToBottom = false
      }
    } else {
      const parentRect = e.target.getBoundingClientRect()
      scrollToBottom = (parentRect.bottom - clientBottom) >= 0
      if (chattingStore.isVisibleCheerForTeamPanel) {
        scrollToBottom = false
      }
    }

    chattingStore.setChatAreaScrolledToBottom(currentTabIndexKey, scrollToBottom)

    clearTimeout(e.target._scrollTid)
    // eslint-disable-next-line no-underscore-dangle
    e.target._scrollTid = setTimeout(() => {
      if (e.target.scrollTop === 0) {
        const beforeHeight = parentRefs.current[currentTabIndexKey].scrollHeight
        let hasMore = false
        switch (currentTabIndexKey) {
          case CHAT_TAB_INDEX_KEY.ALL:
            chattingStore.lazyLoadAllChatMessageList()
            hasMore = chattingStore.hasMoreAllChatMessageList()
            break
          case CHAT_TAB_INDEX_KEY.RECEIVED_MESSAGE:
            chattingStore.lazyLoadReplyChatMessageList()
            hasMore = chattingStore.hasMoreReplyChatMessageList()
            break
          case CHAT_TAB_INDEX_KEY.SHARED_BET_HISTORY:
            chattingStore.lazyLoadBetHistoryChatMessageList()
            hasMore = chattingStore.hasMoreBetHistoryChatMessageList()
            break
        }

        if (hasMore) { // 채팅 추가 로드
          const afterHeight = parentRefs.current[currentTabIndexKey].scrollHeight
          e.target.scrollTop = afterHeight - beforeHeight // 스크롤 포지션 유지를 위해...
        }
      }
    }, 300)
  }

  const removeAllEventListeners = () => {
    parentRefs.current[CHAT_TAB_INDEX_KEY.ALL]?.parentNode.removeEventListener('scroll', chatListScrollHandler, true)
    parentRefs.current[CHAT_TAB_INDEX_KEY.RECEIVED_MESSAGE]?.parentNode.removeEventListener('scroll', chatListScrollHandler, true)
    parentRefs.current[CHAT_TAB_INDEX_KEY.SHARED_BET_HISTORY]?.parentNode.removeEventListener('scroll', chatListScrollHandler, true)
  }

  useEffect(() => {
    removeAllEventListeners()

    parentRefs.current[currentTabIndexKey]?.parentNode.addEventListener('scroll', chatListScrollHandler, true)
    return () => removeAllEventListeners()
  }, [currentTabIndexKey])

  useEffect(() => {
    const scrollToBottom = chatAreaScrolledToBottom[currentTabIndexKey]

    if (
      ((isMobile && isVisibleChattingModal) || !isMobile)
      && (scrollToBottom || chatMessageSending)
      && !chattingStore.isVisibleCheerForTeamPanel
    ) { // 스크롤을 최상단으로 이동시 새로운 채팅이 입력되더라도 스크롤이 아래로 이동하지 않게 하기 위해.
      chattingStore.setDelayChatAreaScrollToBottom()
    }
  }, [allChatMessageList, replyChatMessageList, shardBetHistoryChatMessageList, currentTabIndexKey, chatMessageSending, isVisibleChattingModal])

  const getChatMessageList = () => {
    switch (currentTabIndexKey) {
      case CHAT_TAB_INDEX_KEY.RECEIVED_MESSAGE:
        return replyChatMessageList
      case CHAT_TAB_INDEX_KEY.SHARED_BET_HISTORY:
        return shardBetHistoryChatMessageList
      default:
        return allChatMessageList
    }
  }

  const chatMessageList = getChatMessageList()

  return (
    <Fragment>
      {chatMessageList.map(chatMsg => (
        <ChatContent
          key={`${chatMsg.id}_${chatMsg.chatId}`}
          chatMessage={chatMsg}
          onlyFavoriteUserMessage={onlyFavoriteUserMessage}
          favoriteUserListObject={favoriteUserListObject}
          blockUserListObject={blockUserListObject}
          currentTabIndexKey={currentTabIndexKey}
          chattingOptions={chattingOptions}
          fontSize={fontSize}
        />
      ))}
    </Fragment>
  )
})
